export const Divisor = () => {
    return <div className="sl-information-divisor"></div>;
};
